import { Fragment, useEffect, useState } from "react";
import {
  ArrowDownCircleIcon,
  EllipsisHorizontalCircleIcon,
  EllipsisVerticalIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { Menu, Transition } from "@headlessui/react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { mainSelectedTab } from "../../atoms";
import moment from "moment";
import AddButton from "../../../../components/AddButton";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useHistory } from "react-router-dom";
import { useGetSecurityByOfficeId } from "../../Security/hooks/useGetSecurityByOfficeId";
import { useCameraTypes1 } from "modules/CarrierAgreementMgmt/Security/hooks/useCameraTypes1";
import { useCameraTypes2 } from "modules/CarrierAgreementMgmt/Security/hooks/useCameraTypes2";
import {
  securityFromOffice,
  SecurityShowState,
  securityViewData,
  securityOfficeId,
  SecurityAddState,
  SecurityEditState,
  rowForEditSecurity,
  securityAddButton,
  selectedRowsSecurity,
  CameraModalState,
  OfficeEditSecurity,
  AlarmModalState,
  FireAlarmSystemModalState,
  SafeModalState,
  DoorBuzzerModalState,
  officeKeyModalState,
  HvacModalState,
  securityOfficeBrand,
  securityOfficeState,
  securityOfficeStatus,
  AlarmForEdit,
  FireAlarmSystemForEdit,
  CameraForEdit,
  SafeForEdit,
  DoorBuzzerForEdit,
  OfficeKeysForEdit,
  HvacForEdit,
  CameraSaving,
  CardReaderForEdit,
  cardReaderFormState,
  ActionType,
  cardReaderEditDatas,
  CardReaderState,
  CameraForEditFromOffice,
  recordNumberForEdit,
} from "../../Security/atoms/atoms";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { ChevronRightIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";
import { useEmployees } from "../../Employees/Confie/hooks/useEmployees";
import { useCamerasAndLocation } from "../../Security/hooks/useCamerasAndLocation";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import { useAlarmsByRecordNumber } from "../../Security/hooks/useAlarmsByRecordNumber";
import { useFireAlarmSystemsByRecordNumber } from "../../Security/hooks/useFireAlarmSystemsByRecordNumber";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useGetCamerasByRecordNumber } from "../../Security/hooks/useGetCamerasByRecordNumber";
import { useGetSafeDetailsByRecordNumber } from "../../Security/hooks/useGetSafeDetailsByRecordNumber";
import { useGetDoorBuzzersByRecordNumber } from "../../Security/hooks/useGetDoorBuzzersByRecordNumber";
import { useGetOfficeKeysByRecordNumber } from "../../Security/hooks/useGetOfficeKeysByRecordNumber";
import { useGetHvacsByRecordNumber } from "../../Security/hooks/useGetHvacsByRecordNumber";
import useDeleteOfficeKey from "../../Security/hooks/useDeleteOfficeKey";
import useDeleteHvac from "../../Security/hooks/useDeleteHvac";
import useDeleteAlarm from "../../Security/hooks/useDeleteAlarm";
import useDeleteFireAlarmSystem from "../../Security/hooks/useDeleteFireAlarmSystem";
import useDeleteCamera from "../../Security/hooks/useDeleteCamera";
import useDeleteSafe from "../../Security/hooks/useDeleteSafe";
import useDeleteDoorBuzzer from "../../Security/hooks/useDeleteDoorBuzzer";
import { downloadSourceFile } from "../../../../actions/CarrierAgreementMgmt/Security";
import ChevronRight from "@material-ui/icons/ChevronRight";
import SideNavDownloadBtn from "../../../../components/buttons/SideNavDownloadBtn";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { VendorTabs } from "../../../VendorTab/VendorTab";
import { useGetCardReaderByRecordNumber } from "modules/CarrierAgreementMgmt/Security/hooks/useGetCardReaderByRecordNumber";
import useDeleteCardReader from "modules/CarrierAgreementMgmt/Security/hooks/useDeleteCardReader";

const OfficeSecurity = ({ data }) => {
  const [securityDetails, setSecurityDetails] = useState();
  const [securityAlarms, setSecurityAlarms] = useState([]);
  const [securityAlarmsLoading, setSecurityAlarmsLoading] = useState(true);
  const [, setShowFromOffice] = useRecoilState(securityFromOffice);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [, setShowState] = useRecoilState(SecurityShowState);
  const [, setRowViewData] = useRecoilState(securityViewData);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const { data: securityData } = useGetSecurityByOfficeId(data.officeId);
  const [, setSecurityOfficeId] = useRecoilState(securityOfficeId);
  const [, setAddState] = useRecoilState(SecurityAddState);
  const [, setEditState] = useRecoilState(SecurityEditState);
  const [, setRowSecurityForEdit] = useRecoilState(rowForEditSecurity);
  const [, setDisableAddButton] = useRecoilState(securityAddButton);
  const [showSafeCardModal, setShowSafeCardModal] =
    useRecoilState(SafeModalState);
  const [showDoorBuzzerCardModal, setShowDoorBuzzerCardModal] =
    useRecoilState(DoorBuzzerModalState);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsSecurity);
  const [showDeactivateModalAlarm, setShowDeactivateModalAlarm] =
    useState(false);
  const [showDeactivateModalCamera, setShowDeactivateModalCamera] =
    useState(false);
  const [showDeactivateModalCardReader, setShowDeactivateModalCardReader] =
    useState(false);
  const [showDeactivateModalFireAlarmSystem, setShowDeactivateModalFireAlarmSystem] =
    useState(false);
  const [showDeactivateModalSafeDetails, setShowDeactivateModalSafeDetails] =
    useState(false);
  const [showDeactivateModalDoorBuzzer, setShowDeactivateModalDoorBuzzer] =
    useState(false);
  const [showDeactivateModalOfficeKey, setShowDeactivateModalOfficeKey] =
    useState(false);
  const [showDeactivateModalHvac, setShowDeactivateModalHvac] = useState(false);
  const [forDeleteDetails, setForDeleteDetails] = useState();
  const [hasDeletePermission, setHasDeletePermission] = useState(false);
  const queryClient = useQueryClient();
  const [showCameraCardModal, setShowCameraCardModal] =
    useRecoilState(CameraModalState);
  const [, setShowCardReaderModal] = useRecoilState(CardReaderState);
  const [, setShowCardReaderCardModal] = useState(false);
  const [showAlarmCardModal, setShowAlarmCardModal] =
    useRecoilState(AlarmModalState);
  const [, setShowFireAlarmSystemCardModal] =
    useRecoilState(FireAlarmSystemModalState);
  const [officeEditSecurity, setOfficeEditSecurity] =
    useRecoilState(OfficeEditSecurity);
  const [showOfficeKeyCardModal, setShowOfficeKeyCardModal] =
    useRecoilState(officeKeyModalState);
  const [showHvacCardModal, setShowHvacCardModal] =
    useRecoilState(HvacModalState);
  const [alarmForEditData, setAlarmForEditData] = useRecoilState(AlarmForEdit);
  const [, setFireAlarmSystemForEditData] = useRecoilState(FireAlarmSystemForEdit);
  const [cameraForEditData, setCameraForEditData] =
    useRecoilState(CameraForEdit);
  const [cameraForEditFromOfficeData, setCameraForEditFromOfficeData] =
    useRecoilState(CameraForEditFromOffice);
  const [, setCardReaderForEdit] = useRecoilState(CardReaderForEdit);
  const [safeForEditData, setSafeForEditData] = useRecoilState(SafeForEdit);
  const [doorBuzzerForEditData, setDoorBuzzerForEditData] =
    useRecoilState(DoorBuzzerForEdit);
  const [hvacForEditData, setHvacForEditData] = useRecoilState(HvacForEdit);
  const [officeKeysForEditData, setOfficeKeysForEditData] =
    useRecoilState(OfficeKeysForEdit);
  const editSecurity = PERMISSIONS.permission_security_edit;
  const [, setSecurityOfficeStatus] = useRecoilState(securityOfficeStatus);
  const [, setSecurityOfficeBrand] = useRecoilState(securityOfficeBrand);
  const [, setSecurityOfficeState] = useRecoilState(securityOfficeState);
  const deletePermission = PERMISSIONS.permission_security_delete;
  const [, setSelectedRecordNumber] = useRecoilState(recordNumberForEdit);

  useEffect(() => {
    if (securityData) {
      setSecurityDetails(securityData);
    }
  }, [securityData]);
  const securityRecNum = securityDetails?.recordNumber;
  const { data: employees, isLoading: empLoading } = useEmployees();
  const { data: alarms } = useAlarmsByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );
  const { data: cameras } = useGetCamerasByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );

  const { data: camTypes1 } = useCameraTypes1();
  const camTypes1Option = camTypes1?.data?.map((x) => {
    return {
      id: x.id,
      value: x.id,
      label: x.cameraType1,
    };
  });

  const { data: camTypes2 } = useCameraTypes2();
  const camTypes2Option = camTypes2?.data?.map((x) => {
    return {
      id: x.id,
      value: x.id,
      label: x.cameraType2,
    };
  });
  const { data: cardreaders } = useGetCardReaderByRecordNumber({
    id: securityRecNum,
  });

  const { data: fireAlarmSystems } = useFireAlarmSystemsByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );

  const { data: safeDetails } = useGetSafeDetailsByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );
  const { data: doorBuzzers } = useGetDoorBuzzersByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );
  const { data: officeKeys } = useGetOfficeKeysByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );
  const { data: hvacs } = useGetHvacsByRecordNumber(
    securityRecNum ? securityRecNum : 0
  );
  const [cameraDetails, setCameraDetails] = useState([]);
  const [, setAlarmDetails] = useState([]);
  const [, setSafeDetails] = useState([]);
  const [, setCardReaderDetails] = useState([]);
  const [, setFireAlarmSystemDetails] = useState([]);
  const [, setHvacDetails] = useState([]);
  const [, setDoorBuzzerDetails] = useState([]);
  const [, setOfficeKeyDetails] = useState([]);

  const editDisabledSecurity = PERMISSIONS.permission_security_edit;

  const employeeList = employees?.map((x) => {
    return {
      id: x.employeeId,
      value: x.employeeId?.toString(),
      label:
        x.firstname +
        (x.middlename ? " " + x.middlename + " " : " ") +
        x.lastname,
      email: x.email,
      status: x.status,
      manager: x.reportsToFullname,
      officeName: x.officeName,
      fullName:
        x.firstname +
        (x.middlename ? " " + x.middlename + " " : " ") +
        x.lastname,
    };
  });

  const { data: camAndLocation } = useCamerasAndLocation();
  const camAndLocationOption = camAndLocation?.data?.map((x) => {
    return {
      id: x.id,
      value: x.id?.toString(),
      label: x.camerasAndLocation,
    };
  });

  const handleLink = () => {
    const url = "/officesettings/security";
    history.push(url);
    let userTabs = [
      {
        to: "",
      },
    ];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    userTabs.shift();
    const index = userTabs.findIndex((c) => c.to === url);
    setSelectedIndex(index);
  };

  useEffect(() => {
    setSelectedRows([]);
  }, [setSelectedRows]);

  //Delete for Alarm
  const {
    mutate: deleteAlarm,
    isSuccess: deleteAlarmSuccess,
    data: deleteAlarmResult,
    isError: deleteAlarmError,
    reset: resetDeleteAlarmData,
  } = useDeleteAlarm();

  //Delete for cardreader
  const {
    mutate: deleteCardreader,
    isSuccess: deleteCardreaderSuccess,
    data: deleteCardreaderResult,
    reset: resetDeleteCardreaderData,
  } = useDeleteCardReader();

  //Delete for Fire Alarm System
  const {
    mutate: deleteFireAlarmSystem,
    isSuccess: deleteFireAlarmSystemSuccess,
    data: deleteFireAlarmSystemResult,
    isError: deleteFireAlarmSystemError,
    reset: resetDeleteFireAlarmSystemData,
  } = useDeleteFireAlarmSystem();

  //Delete for Camera
  const {
    mutate: deleteCamera,
    isSuccess: deleteCameraSuccess,
    data: deleteCameraResult,
    isError: deleteCameraError,
    reset: resetDeleteCameraData,
  } = useDeleteCamera();

  //Delete for Safe Details
  const {
    mutate: deleteSafe,
    isSuccess: deleteSafeDetailsSuccess,
    data: deleteSafeDetailsResult,
    isError: deleteSafeDetailsError,
    reset: resetDeleteSafeDetailsData,
  } = useDeleteSafe();

  //Delete for Door Buzzer
  const {
    mutate: deleteDoorBuzzer,
    isSuccess: deleteDoorBuzzerSuccess,
    data: deleteDoorBuzzerResult,
    isError: deleteDoorBuzzerError,
    reset: resetDeleteDoorBuzzerData,
  } = useDeleteDoorBuzzer();

  //Delete for Office Key
  const {
    mutate: deleteOfficeKey,
    isSuccess: deleteOfficeKeySuccess,
    data: deleteOfficeKeyResult,
    isError: deleteOfficeKeyError,
    reset: resetDeleteOfficeKeyData,
  } = useDeleteOfficeKey();

  //Delete for HVAC
  const {
    mutate: deleteHvac,
    isSuccess: deleteHvacSuccess,
    data: deleteHvacResult,
    isError: deleteHvacError,
    reset: resetDeleteHvacData,
  } = useDeleteHvac();

  //Deactivate for Alarm
  const handleDeactivate = () => {
    deleteAlarm(forDeleteDetails);
    setShowDeactivateModalAlarm(false);
  };

  //Deactivate for CArderader
  const handleDeactivateCardreader = () => {
    deleteCardreader(forDeleteDetails);
    setShowDeactivateModalCardReader(false);
  };

  //Deactivate for Fire Alarm System
  const handleDeactivateFireAlarmSystem = () => {
    deleteFireAlarmSystem(forDeleteDetails);
    setShowDeactivateModalFireAlarmSystem(false);
  };

  //Deactivate for Camera
  const handleDeactivateCam = () => {
    const payload = {
      id: forDeleteDetails?.id,
      recordNumber: forDeleteDetails?.recordNumber,
    };
    deleteCamera(payload);
    setShowDeactivateModalCamera(false);
  };

  //Deactivate for Safe Details
  const handleDeactivateSafe = () => {
    deleteSafe(forDeleteDetails);
    setShowDeactivateModalSafeDetails(false);
  };

  //Deactivate for Door Buzzer
  const handleDeactivateDB = () => {
    deleteDoorBuzzer(forDeleteDetails);
    setShowDeactivateModalDoorBuzzer(false);
  };

  //Deactivate for Office Key
  const handleDeactivateOfficeKey = () => {
    deleteOfficeKey(forDeleteDetails);
    setShowDeactivateModalOfficeKey(false);
  };

  //Deactivate for HVAC
  const handleDeactivateHvac = () => {
    deleteHvac(forDeleteDetails);
    setShowDeactivateModalHvac(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">
      {"Are you sure you want to deactivate this?"}
    </div>
  );

  // Toast for deactivate alarm
  if (deleteAlarmSuccess && deleteAlarmResult) {
    if (deleteAlarmResult.status === 201 || deleteAlarmResult.status === 200) {
      toast.fire("Success", "Alarm Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetAlarmsByRecordNumber");
    }
    resetDeleteAlarmData();
  }

  // Toast for deactivate cardreader
  if (deleteCardreaderSuccess && deleteCardreaderResult) {
    if (
      deleteCardreaderResult.status === 201 ||
      deleteCardreaderResult.status === 200
    ) {
      toast.fire("Success", "Card Reader Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetCardReaderByRecordNumber");
    }
    resetDeleteCardreaderData();
  }


  // Toast for deactivate fire alarm system
  if (deleteFireAlarmSystemSuccess && deleteFireAlarmSystemResult) {
    if (deleteFireAlarmSystemResult.status === 201 || deleteFireAlarmSystemResult.status === 200) {
      toast.fire("Success", "Fire Alarm System Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetFireAlarmSystemsByRecordNumber");
    }
    resetDeleteFireAlarmSystemData();
  }

  // Toast for deactivate camera
  if (deleteCameraSuccess && deleteCameraResult) {
    if (
      deleteCameraResult.status === 201 ||
      deleteCameraResult.status === 200
    ) {
      toast.fire("Success", "Camera Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetCamerasByRecordNumber");
    }
    resetDeleteCameraData();
  }

  // Toast for deactivate safe details
  if (deleteSafeDetailsSuccess && deleteSafeDetailsResult) {
    if (
      deleteSafeDetailsResult.status === 201 ||
      deleteSafeDetailsResult.status === 200
    ) {
      toast.fire(
        "Success",
        "Safe Details Deactivated Successfully.",
        "success"
      );
      queryClient.invalidateQueries("GetSafeDetailsByRecordNumber");
    }
    resetDeleteSafeDetailsData();
  }

  // Toast for deactivate door buzzer
  if (deleteDoorBuzzerSuccess && deleteDoorBuzzerResult) {
    if (
      deleteDoorBuzzerResult.status === 201 ||
      deleteDoorBuzzerResult.status === 200
    ) {
      toast.fire("Success", "Door Buzzer Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetDoorBuzzersByRecordNumber");
    }
    resetDeleteDoorBuzzerData();
  }

  // Toast for deactivate office key
  if (deleteOfficeKeySuccess && deleteOfficeKeyResult) {
    if (
      deleteOfficeKeyResult.status === 201 ||
      deleteOfficeKeyResult.status === 200
    ) {
      toast.fire("Success", "Office Key Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetOfficeKeysByRecordNumber");
    }
    resetDeleteOfficeKeyData();
  }

  // Toast for deactivate HVAC
  if (deleteHvacSuccess && deleteHvacResult) {
    if (deleteHvacResult.status === 201 || deleteHvacResult.status === 200) {
      toast.fire("Success", "HVAC Deactivated Successfully.", "success");
      queryClient.invalidateQueries("GetHvacsByRecordNumber");
    }
    resetDeleteHvacData();
  }
  const onClickSecurity = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setRowViewData(rowData);
  };
  const onClickAlarm = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setShowAlarmCardModal(true);
    setRowViewData(rowData);
    setAlarmDetails(rowData);
  };
  const onClickCamera = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setRowViewData(rowData);
    setShowCameraCardModal(true);
    setCameraDetails(rowData);
  };

  const onClickCardReader = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setShowCardReaderCardModal(true);
    setShowCardReaderModal(true);
    setRowViewData(rowData);
    setCardReaderDetails(rowData);
  };
  const onClickFireAlarmSystem = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setShowFireAlarmSystemCardModal(true);
    setRowViewData(rowData);
    setFireAlarmSystemDetails(rowData);
  };
  const onClickSafe = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setRowViewData(rowData);
    setShowSafeCardModal(true);
    setSafeDetails(rowData);
  };
  const onClickDoorBuzzer = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setRowViewData(rowData);
    setShowDoorBuzzerCardModal(true);
    setDoorBuzzerDetails(rowData);
  };
  const onClickOfficeKey = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setRowViewData(rowData);
    setShowOfficeKeyCardModal(true);
    setOfficeKeyDetails(rowData);
  };
  const onClickHvac = (rowData) => {
    setShowFromOffice(true);
    handleLink();
    setShowState(true);
    setRowViewData(rowData);
    setShowHvacCardModal(true);
    setHvacDetails(rowData);
  };
  const [, setCardReaderActionState] = useRecoilState(cardReaderFormState);
  const [, setEditDataCardReader] = useRecoilState(cardReaderEditDatas);

  //Function for Add button
  const onClickAdd = (state, rowData, modal) => {
    handleLink();
    setShowFromOffice(true);
    setSecurityOfficeId(rowData.officeId);
    setSecurityOfficeBrand(rowData.officeBrand);
    setSecurityOfficeState(rowData.officeState);
    setSecurityOfficeStatus(rowData.officeStatus);

    if (state === "ForAdd") {
      setAddState(true);
      setEditState(false);
    } else {
      if (modal === "security") {
        const fileCateg = rowData?.fileCategoryList
          ? rowData?.fileCategoryList?.map((file, index) => {
            return {
              ...file,
              fileCategory: file,
              parentRow: index > 0 ? false : true,
              tableName: "fileCategoryList",
              fileName: rowData.fileName,
            };
          })
          : [];
        let filesImagesObj = rowData;
        setCardReaderForEdit(cardreaders);
        setRowSecurityForEdit({
          ...filesImagesObj,
          contractRenewalDate: rowData.contractRenewalDate
            ? rowData.contractRenewalDate?.slice(0, 10)
            : null,
          fileCategoryList: [...fileCateg],
          fileCategoryListName: [...fileCateg],
        });
        setEditState(true);
        setAddState(false);
        setShowFromOffice(true);
      } else {
        setCardReaderForEdit(cardreaders);
        if (modal === "alarm") {
          let alarmObj = rowData;
          setShowAlarmCardModal(true);
          setAlarmForEditData({
            ...alarmObj,
            alarmInstallDate: rowData.alarmInstallDate
              ? rowData.alarmInstallDate?.slice(0, 10)
              : null,
            id: rowData.id,
          });
          setRowSecurityForEdit({
            ...alarmObj,
            alarmInstallDate: rowData.alarmInstallDate
              ? rowData.alarmInstallDate?.slice(0, 10)
              : null,
            contractRenewalDate: rowData?.contractRenewalDate
              ? rowData?.contractRenewalDate?.slice(0, 10)
              : null,
            cancellationDate: rowData?.cancellationDate
              ? rowData?.cancellationDate?.slice(0, 10)
              : null,
          });
        }
        if (modal === "cardreader") {
          setShowCardReaderCardModal(true);
          setEditDataCardReader(rowData);
          setCardReaderDetails(rowData);
          setRowSecurityForEdit(rowData);
          setCardReaderForEdit(cardreaders);
          setCardReaderActionState(ActionType.EDIT);
          setEditState(true);
          setAddState(false);
        }

        if (modal === "fireAlarmSystem") {
          let fireAlarmSystemObj = rowData;

          setShowFireAlarmSystemCardModal(true);
          setFireAlarmSystemForEditData({
            ...fireAlarmSystemObj,
            installDate: rowData.installDate
              ? rowData.installDate?.slice(0, 10)
              : null,
            fireAlarmSystemId: rowData.fireAlarmSystemId,
          });
          setRowSecurityForEdit({
            ...fireAlarmSystemObj,
            installDate: rowData.installDate
              ? rowData.installDate?.slice(0, 10)
              : null,
            cancellationDate: rowData?.cancellationDate
              ? rowData?.cancellationDate?.slice(0, 10)
              : null,
          });
        }

        if (modal === "camera") {
          setRowSecurityForEdit(rowData);
          setShowCameraCardModal(true);
          setCameraForEditData(rowData);
          setCameraForEditFromOfficeData(rowData);
        }
        if (modal === "safe") {
          setShowSafeCardModal(true);
          setRowSecurityForEdit(rowData);
        }
        if (modal === "doorBuzzer") {
          let dbObj = rowData;
          setShowDoorBuzzerCardModal(true);
          setDoorBuzzerForEditData({
            ...dbObj,
            dbinstallDate: rowData.dbinstallDate
              ? rowData.dbinstallDate?.slice(0, 10)
              : null,
          });
          setRowSecurityForEdit({
            ...dbObj,
            dbinstallDate: rowData.dbinstallDate
              ? rowData.dbinstallDate?.slice(0, 10)
              : null,
          });
        }
        if (modal === "officeKeys") {
          let oKObj = rowData;
          const keysValue = rowData?.keysAssignedTo?.split(",");
          const filteredValue = keysValue?.map((x) =>
            employeeList?.filter((b) => b.value === x)
          );
          const keysAssignedValue = filteredValue?.map(
            (x) => x.map((x) => x)[0]
          );
          setOfficeKeysForEditData(rowData);
          setRowSecurityForEdit({
            ...oKObj,
            keysAssignedTo: rowData?.keysAssignedTo ? keysAssignedValue : null,
            okvendorAddress:
              rowData?.street +
              " " +
              rowData?.city +
              ", " +
              rowData?.state +
              " " +
              rowData?.zipCode,
          });
          setShowOfficeKeyCardModal(true);
        }
        if (modal === "hvac") {
          let hvacObj = rowData;
          setHvacForEditData(hvacObj);
          setRowSecurityForEdit({
            ...hvacObj,
            hvacinstallDate: rowData.hvacinstallDate
              ? rowData.hvacinstallDate?.slice(0, 10)
              : null,
            firstMaintenanceDate: rowData.firstMaintenanceDate
              ? rowData.firstMaintenanceDate?.slice(0, 10)
              : null,
          });
          setShowHvacCardModal(true);
        }
        if (modal === "FilesAndImages") {
          const fileCateg = rowData?.fileCategoryList?.map((file, index) => {
            return {
              ...file,
              fileCategory: file,
              parentRow: index > 0 ? false : true,
              tableName: "fileCategoryList",
              fileName: rowData.fileName,
            };
          });
          let filesImagesObj = rowData;
          setRowSecurityForEdit({
            ...filesImagesObj,
            contractRenewalDate: rowData.contractRenewalDate
              ? rowData.contractRenewalDate?.slice(0, 10)
              : null,
            fileCategoryList: [...fileCateg],
            fileCategoryListName: [...fileCateg],
          });
        }
      }
      setEditState(true);
      setAddState(false);
    }
  };

  if (securityRecNum !== undefined) {
    setDisableAddButton(true);
  }
  //Download Files and Images
  const downloadFile = (fileName) => {
    try {
      downloadSourceFile(fileName).then((content) => {
        if (content.status === 200) {
          var url = window.URL.createObjectURL(content.data);
          let tempLink = document.createElement("a");
          tempLink.href = url;
          tempLink.setAttribute("download", fileName);
          tempLink.click();
          toast.fire("Success", "File downloaded successfully", "success");
        }
        if (content.status === 404) {
          toast.fire(
            "Error downloading file:",
            "The file has not been found in the system.",
            "error"
          );
        }
      });
    } catch (error) {
      toast.fire(
        "Failed to download file",
        "Server Error: Cannot download file due to: " + error,
        "error"
      );
    }
  };

  // Alarm Section
  const SecurityAlarmAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Alarm
              </div>
            </Disclosure.Button>
            {/* <h1 className="font-bold text-primary ml-2">Alarm</h1> */}
            <Disclosure.Panel className="text-xs bg-white">
              <div>
                {alarms &&
                  alarms?.map((alarm, i) => {
                    return <SecurityAlarmCard key={i} securityAlarm={alarm} />;
                  })}
              </div>
              {alarms && alarms.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Alarm Found
                </div>
              )}
            </Disclosure.Panel>
            {showDeactivateModalAlarm && (
              <ConfirmBoxDelete
                ModalTitle="Security Alarm"
                qConfirmation={deleteMessage}
                isOpen={showDeactivateModalAlarm}
                onClose={() => setShowDeactivateModalAlarm(false)}
                onClickFunction={() => handleDeactivate()}
                cancelButtonRef={undefined}
              />
            )}
          </>
        )}
      </Disclosure>
    </div>
  );
  const SecurityAlarmCard = ({ securityAlarm }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickAlarm(securityAlarm)}
              >
                {securityAlarm.id
                  ? "S-" + String(securityAlarm.id).padStart(4, "0")
                  : ""}
              </div>
            </span>
            {(userPermissions.includes(editSecurity) ||
              userPermissions.includes(deletePermission)) && (
                <Menu as="div" className="items-center flex relative">
                  <div>
                    <Menu.Button className="">
                      <EllipsisHorizontalCircleIcon
                        className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="px-1 py-1 space-y-1">
                        {userPermissions.includes(editSecurity) && (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() =>
                                  onClickAdd("ForEdit", securityAlarm, "alarm")
                                }
                              >
                                <label className="cursor-pointer fontLabel text-quaternary flex items-center hover:text-primary underline px-2 text-xs font-medium">
                                  <PencilSquareIcon className="h-4 w-4 mr-1" />
                                  Edit
                                </label>
                              </button>
                            )}
                          </Menu.Item>
                        )}

                        {userPermissions.includes(deletePermission) && (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => {
                                  setShowDeactivateModalAlarm(true);
                                  setForDeleteDetails(securityAlarm);
                                }}
                                disabled={!securityAlarm.isActive}
                                className={
                                  !securityAlarm.isActive
                                    ? "opacity-50"
                                    : "opacity-100"
                                }
                              >
                                <label className="cursor-pointer fontLabel text-secondary flex items-center hover:text-hsecondary underline px-2 text-xs font-medium">
                                  <TrashIcon className="h-4 w-4 mr-1" />
                                  Deactivate
                                </label>
                              </button>
                            )}
                          </Menu.Item>
                        )}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              )}
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Alarm Vendor:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityAlarm.vendorId,
                      officeSecurityData: securityAlarm,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...VendorTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">{securityAlarm.vendorName}</span>
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Account Number:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityAlarm.accountNumber}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Alarm Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityAlarm.alarmTypeName}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Vendor Phone:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityAlarm.vendorPhone}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Camera Section
  const SecurityCameraAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Camera
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs bg-white">
              {cameras &&
                cameras.map((camera, i) => (
                  <SecurityCameraCard key={i} securityCamera={camera} />
                ))}
              {cameras && cameras.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Camera Found
                </div>
              )}
            </Disclosure.Panel>
            {showDeactivateModalCamera && (
              <ConfirmBoxDelete
                ModalTitle="Security Camera"
                qConfirmation={deleteMessage}
                isOpen={showDeactivateModalCamera}
                onClose={() => setShowDeactivateModalCamera(false)}
                onClickFunction={() => handleDeactivateCam()}
                cancelButtonRef={undefined}
              />
            )}
          </>
        )}
      </Disclosure>
    </div>
  );

  const SecurityCameraCard = ({ securityCamera }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2  border-gray-200 ">
          <div className="flex justify-between  gap-2">
            <div
              className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer mt-1 mb-2 ml-3"
              onClick={() => {
                onClickCamera(securityCamera);
              }}
            >
              {securityCamera.recordNumber
                ? "C-" + String(securityCamera.recordNumber).padStart(4, "0")
                : ""}
            </div>
            <Menu as="div" className="items-center flex relative">
              <div>
                <Menu.Button className="">
                  <EllipsisHorizontalCircleIcon
                    className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                    aria-hidden="true"
                  />
                </Menu.Button>
              </div>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 mt-2 w-28 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
                  {userPermissions.includes(editSecurity) && (
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className="w-full"
                            onClick={() => {
                              onClickAdd("ForEdit", securityCamera, "camera");
                            }}
                          >
                            <label className="cursor-pointer fontLabel text-quaternary flex items-center justify-start gap-1 hover:text-primary underline px-2 text-xs font-medium">
                              <PencilSquareIcon className="h-4 w-4" /> Edit
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  )}

                  {userPermissions.includes(deletePermission) && (
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className="w-full"
                            onClick={() => {
                              setShowDeactivateModalCamera(true);
                              setForDeleteDetails(securityCamera);
                            }}
                            disabled={securityCamera.isActive === false}
                          >
                            <label
                              className={`cursor-pointer fontLabel flex items-center justify-start gap-1 underline px-2 text-xs font-medium text-secondary hover:text-hsecondary ${!securityCamera.isActive ||
                                securityCamera.isActive === 0
                                ? "opacity-50"
                                : "opacity-100"
                                }`}
                            >
                              <TrashIcon className="h-4 w-4" /> Deactivate
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  )}
                </Menu.Items>
              </Transition>
            </Menu>
          </div>

          <div className="flex justify-between m-1 gap-2">
            <div className="grid  grid-cols-2">
              <label className=" expandedLabel fontExpand text-left ml-2">
                Camera Make:
              </label>
              <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
                <span className="pr-2">{securityCamera.cameraMake}</span>
              </div>
            </div>
          </div>
          <div className="flex justify-between m-1 gap-2">
            <div className="grid  grid-cols-2">
              <label className=" expandedLabel fontExpand text-left ml-2">
                Camera Model:
              </label>
              <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
                <span className="pr-2">{securityCamera.cameraModel}</span>
              </div>
            </div>
          </div>

          {securityCamera.cameraLocationsDto?.map((location, i) => {
            const ids = location.camerasAndLocationId
              ?.split(",")
              .map((x) => x.trim());

            const matchedLocations = ids
              ?.map((id) =>
                camAndLocationOption?.find((opt) => opt?.value === id)
              )
              ?.filter(Boolean); // filter out undefined matches

            return (
              <Disclosure key={location.id} defaultClose>
                {({ open }) => (
                  <>
                    <div className="m-2 bg-white rounded-lg shadow-md">
                      <Disclosure.Button className="disclosureBtn ml-2">
                        <ChevronRight
                          className={`${open ? "transform rotate-90" : " text-gray-500"
                            } text-gray-500 w-5 h-5`}
                        />
                        <div className="text-gray-500">Location and Types</div>
                      </Disclosure.Button>
                      <Disclosure.Panel className="text-xxs">
                        <div className="w-full borderContainer pb-2 bg-white px-6">
                          <div className="grid grid-cols-1">
                            <div>
                              <div className="grid grid-cols-2">
                                <label className="expandedLabel fontExpand text-left ml-1">
                                  Number and Location:
                                </label>
                                <div className="expandedLabel fontExpand text-left ml-1">
                                  <span className="pr-2">
                                    {matchedLocations?.length > 0
                                      ? matchedLocations
                                        .map((loc) => loc.label)
                                        .join(", ")
                                      : "No Camera Location"}
                                  </span>
                                </div>
                              </div>
                              <div className="grid grid-cols-2">
                                <label className="expandedLabel fontExpand text-left ml-1">
                                  Camera Type 1:
                                </label>
                                <div className="expandedLabel fontExpand text-left ml-1 truncate ...">
                                  <span className="pr-2">
                                    {camTypes1Option?.find(
                                      (type) =>
                                        type.value === location.cameraType1
                                    )?.label ?? "—"}
                                  </span>
                                </div>
                              </div>
                              <div className="grid grid-cols-2">
                                <label className="expandedLabel fontExpand text-left ml-1">
                                  Camera Type 2:
                                </label>
                                <div className="expandedLabel fontExpand text-left ml-1 truncate ...">
                                  <span className="pr-2">
                                    {camTypes2Option?.find(
                                      (type) =>
                                        type.value === location.cameraType2
                                    )?.label ?? "—"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
            );
          })}
        </div>
      </div>
    </div>
  );

  //Cardreader
  const SecurityCardReaderAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Card Reader
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs bg-white">
              <div>
                {Array.isArray(cardreaders) &&
                  cardreaders.map((reader, i) => (
                    <SecurityCardReaderCard
                      key={i}
                      securityCardReader={reader}
                    />
                  ))}
              </div>

              {cardreaders && cardreaders.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Card Reader Found
                </div>
              )}
            </Disclosure.Panel>
            {showDeactivateModalCardReader && (
              <ConfirmBoxDelete
                ModalTitle="Security Card Reader"
                qConfirmation={deleteMessage}
                isOpen={showDeactivateModalCardReader}
                onClose={() => setShowDeactivateModalCardReader(false)}
                onClickFunction={() => handleDeactivateCardreader()}
                cancelButtonRef={undefined}
              />
            )}
          </>
        )}
      </Disclosure>
    </div>
  );

  const SecurityCardReaderCard = ({ securityCardReader }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickCardReader(securityCardReader)}
              >
                {securityCardReader.id
                  ? "S-" + String(securityCardReader.id).padStart(4, "0")
                  : ""}
              </div>
            </span>

            {(userPermissions.includes(editSecurity) ||
              userPermissions.includes(deletePermission)) && (
                <Menu as="div" className="items-center flex relative">
                  <div>
                    <Menu.Button>
                      <EllipsisHorizontalCircleIcon
                        className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 mt-2 w-28 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="px-1 py-1 space-y-1">
                        {userPermissions.includes(editSecurity) && (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() =>
                                  onClickAdd(
                                    "ForEdit",
                                    securityCardReader,
                                    "cardreader"
                                  )
                                }
                                className="w-full"
                              >
                                <label className="cursor-pointer fontLabel text-quaternary flex items-center justify-start gap-1 hover:text-primary underline px-2 text-xs font-medium">
                                  <PencilSquareIcon className="h-4 w-4" /> Edit
                                </label>
                              </button>
                            )}
                          </Menu.Item>
                        )}

                        {userPermissions.includes(deletePermission) && (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => {
                                  setShowDeactivateModalCardReader(true);
                                  setForDeleteDetails(securityCardReader);
                                }}
                                disabled={!securityCardReader.isActive}
                                className={`w-full ${!securityCardReader.isActive
                                  ? "opacity-50"
                                  : "opacity-100"
                                  }`}
                              >
                                <label className="cursor-pointer fontLabel text-secondary flex items-center justify-start gap-1 hover:text-hsecondary underline px-2 text-xs font-medium">
                                  <TrashIcon className="h-4 w-4" /> Deactivate
                                </label>
                              </button>
                            )}
                          </Menu.Item>
                        )}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              )}
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Vendor Name:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityCardReader.vendorId,
                      officeSecurityData: securityCardReader,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...VendorTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">{securityCardReader.vendorName}</span>
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Account Number:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {securityCardReader.accountNumberBrivo}
              </span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Install Date:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {" "}
                {securityCardReader.installDate
                  ? moment(securityCardReader.installDate).format("MM/DD/YYYY")
                  : ""}
              </span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Card Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityCardReader.cardType}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Card Name:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityCardReader.cardName}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Parking Garage Key Card Access:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {securityCardReader.isKeyCardAccess === true
                  ? "Yes"
                  : securityCardReader.isKeyCardAccess === false
                    ? "No"
                    : ""}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Fire Alarm System Section
  const SecurityFireAlarmSystemAccordion = () => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""} text-gray-500 w-2 h-2 `}
              />

              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Fire Alarm System
              </div>
            </Disclosure.Button>

            <Disclosure.Panel className="text-xs bg-white">
              <div>
                {fireAlarmSystems &&
                  fireAlarmSystems?.map((fireAlarmSystem, i) => {
                    return <SecurityFireAlarmSystemCard key={i} securityFireAlarmSystem={fireAlarmSystem} />;
                  })}
              </div>
              {fireAlarmSystems && fireAlarmSystems.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Fire Alarm System Found
                </div>
              )}
            </Disclosure.Panel>
            {showDeactivateModalFireAlarmSystem && (
              <ConfirmBoxDelete
                ModalTitle="Security Fire Alarm System"
                qConfirmation={deleteMessage}
                isOpen={showDeactivateModalFireAlarmSystem}
                onClose={() => setShowDeactivateModalFireAlarmSystem(false)}
                onClickFunction={() => handleDeactivateFireAlarmSystem()}
                cancelButtonRef={undefined}
              />
            )}
          </>
        )}
      </Disclosure>
    </div>
  );
  const SecurityFireAlarmSystemCard = ({ securityFireAlarmSystem }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickFireAlarmSystem(securityFireAlarmSystem)}
              >
                {securityFireAlarmSystem.fireAlarmSystemId
                  ? "FA-" + String(securityFireAlarmSystem.fireAlarmSystemId).padStart(4, "0")
                  : ""}
              </div>
            </span>
            {(userPermissions.includes(editSecurity) ||
              userPermissions.includes(deletePermission)) && (
                <Menu as="div" className="items-center flex relative">
                  <div>
                    <Menu.Button className="">
                      <EllipsisHorizontalCircleIcon
                        className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                        aria-hidden="true"
                      />
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <div className="px-1 py-1 space-y-1">
                        {userPermissions.includes(editSecurity) && (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() =>
                                  onClickAdd("ForEdit", securityFireAlarmSystem, "fireAlarmSystem")
                                }
                              >
                                <label className="cursor-pointer fontLabel text-quaternary flex items-center hover:text-primary underline px-2 text-xs font-medium">
                                  <PencilSquareIcon className="h-4 w-4 mr-1" />
                                  Edit
                                </label>
                              </button>
                            )}
                          </Menu.Item>
                        )}

                        {userPermissions.includes(deletePermission) && (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => {
                                  setShowDeactivateModalFireAlarmSystem(true);
                                  setForDeleteDetails(securityFireAlarmSystem);
                                }}
                                disabled={!securityFireAlarmSystem.isActive}
                                className={
                                  !securityFireAlarmSystem.isActive
                                    ? "opacity-50"
                                    : "opacity-100"
                                }
                              >
                                <label className="cursor-pointer fontLabel text-secondary flex items-center hover:text-hsecondary underline px-2 text-xs font-medium">
                                  <TrashIcon className="h-4 w-4 mr-1" />
                                  Deactivate
                                </label>
                              </button>
                            )}
                          </Menu.Item>
                        )}
                      </div>
                    </Menu.Items>
                  </Transition>
                </Menu>
              )}
          </div>
          <div className="grid  grid-cols-2  ">
            <label className="expandedLabel fontExpand text-left ml-2">
              Fire Alarm System Vendor:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityFireAlarmSystem.vendorId,
                      officeSecurityData: securityFireAlarmSystem,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...VendorTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">{securityFireAlarmSystem.vendorName}</span>
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Account Number:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityFireAlarmSystem.vendorAccountNumber}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Fire Alarm Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityFireAlarmSystem.alarmTypeName}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Vendor Phone:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityFireAlarmSystem.vendorPhone}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Safe Detail section
  const SecuritySafeDetailsAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Safe Details
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs bg-white">
              {safeDetails?.map((safeDetail, i) => {
                return (
                  <SecuritySafeDetailsCard
                    key={i}
                    securitySafeDetails={safeDetail}
                  />
                );
              })}
              {safeDetails && safeDetails.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Safe Detail Found
                </div>
              )}
            </Disclosure.Panel>
            {showDeactivateModalSafeDetails && (
              <ConfirmBoxDelete
                ModalTitle="Security Safe Details"
                qConfirmation={deleteMessage}
                isOpen={showDeactivateModalSafeDetails}
                onClose={() => setShowDeactivateModalSafeDetails(false)}
                onClickFunction={() => handleDeactivateSafe()}
                cancelButtonRef={undefined}
              />
            )}
          </>
        )}
      </Disclosure>
    </div>
  );
  const SecuritySafeDetailsCard = ({ securitySafeDetails }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickSafe(securitySafeDetails)}
              >
                {securitySafeDetails.id
                  ? "S-" + String(securitySafeDetails.id).padStart(4, "0")
                  : ""}
              </div>
            </span>
            {userPermissions.includes(editSecurity) && (
              <Menu as="div" className="items-center flex">
                <div>
                  <Menu.Button className="">
                    <EllipsisHorizontalCircleIcon
                      className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            buttonText="Edit"
                            className={""}
                            onClick={() =>
                              onClickAdd("ForEdit", securitySafeDetails, "safe")
                            }
                            disabled={false}
                          >
                            <label className="cursor-pointer fontLabel text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                              {" "}
                              <PencilSquareIcon className="h-4 w-4 " /> Edit
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                    {userPermissions.includes(deletePermission) ? (
                      <div className="px-1 py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              buttonText="Deactivate"
                              className={
                                !securitySafeDetails.isActive ||
                                  securitySafeDetails.isActive == 0
                                  ? "opacity-50"
                                  : "opacity-100"
                              }
                              onClick={() => {
                                setShowDeactivateModalSafeDetails(true);
                                setForDeleteDetails(securitySafeDetails);
                              }}
                              hasDeletePermission={hasDeletePermission}
                              disabled={securitySafeDetails.isActive === false}
                            >
                              <label className="cursor-pointer fontLabel text-secondary flex items-center place-content-center hover:text-hsecondary underline relative  px-2 text-xs font-medium">
                                {" "}
                                <TrashIcon className="h-4 w-4 " /> Deactivate
                              </label>
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    ) : (
                      ""
                    )}
                  </Menu.Items>
                </Transition>
              </Menu>
            )}
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Safe Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securitySafeDetails.safeType}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Safe Code:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securitySafeDetails.safeCode}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Safe Make:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securitySafeDetails.safeMake}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Safe Model:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securitySafeDetails.safeModel}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Safe Serial Number:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {securitySafeDetails.safeSerialNumber}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Door Buzzer section
  const SecurityDoorBuzzerAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Door Buzzer
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs bg-white">
              {doorBuzzers?.map((doorBuzzer, i) => {
                return (
                  <SecurityDoorBuzzerCard
                    key={i}
                    securityDoorBuzzer={doorBuzzer}
                  />
                );
              })}
              {doorBuzzers && doorBuzzers.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Door Buzzer Found
                </div>
              )}
            </Disclosure.Panel>
            {showDeactivateModalDoorBuzzer && (
              <ConfirmBoxDelete
                ModalTitle="Security Door Buzzer"
                qConfirmation={deleteMessage}
                isOpen={showDeactivateModalDoorBuzzer}
                onClose={() => setShowDeactivateModalDoorBuzzer(false)}
                onClickFunction={() => handleDeactivateDB()}
                cancelButtonRef={undefined}
              />
            )}
          </>
        )}
      </Disclosure>
    </div>
  );
  const SecurityDoorBuzzerCard = ({ securityDoorBuzzer }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickDoorBuzzer(securityDoorBuzzer)}
              >
                {securityDoorBuzzer.siteNumber
                  ? "S-" +
                  String(securityDoorBuzzer.siteNumber).padStart(4, "0")
                  : ""}
              </div>
            </span>
            {userPermissions.includes(editSecurity) && (
              <Menu as="div" className="items-center flex">
                <div>
                  <Menu.Button className="">
                    <EllipsisHorizontalCircleIcon
                      className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            buttonText="Edit"
                            className={""}
                            onClick={() =>
                              onClickAdd(
                                "ForEdit",
                                securityDoorBuzzer,
                                "doorBuzzer"
                              )
                            }
                            disabled={false}
                          >
                            <label className="cursor-pointer fontLabel text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                              {" "}
                              <PencilSquareIcon className="h-4 w-4 " /> Edit
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                    {userPermissions.includes(deletePermission) ? (
                      <div className="px-1 py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              buttonText="Deactivate"
                              className={
                                !securityDoorBuzzer.isActive ||
                                  securityDoorBuzzer.isActive == 0
                                  ? "opacity-50"
                                  : "opacity-100"
                              }
                              onClick={() => {
                                setShowDeactivateModalDoorBuzzer(true);
                                setForDeleteDetails(securityDoorBuzzer);
                              }}
                              hasDeletePermission={hasDeletePermission}
                              disabled={securityDoorBuzzer.isActive === false}
                            >
                              <label className="cursor-pointer fontLabel text-secondary flex items-center place-content-center hover:text-hsecondary underline relative  px-2 text-xs font-medium">
                                {" "}
                                <TrashIcon className="h-4 w-4 " /> Deactivate
                              </label>
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    ) : (
                      ""
                    )}
                  </Menu.Items>
                </Transition>
              </Menu>
            )}
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Site Number:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityDoorBuzzer.siteNumber}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Install Date:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {securityDoorBuzzer?.dbinstallDate !== null
                  ? new Date(
                    securityDoorBuzzer.dbinstallDate
                  ).toLocaleDateString()
                  : ""}
              </span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityDoorBuzzer.type}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2 font-bold">
              Vendor Type:
            </label>
          </div>
          <div className="grid  grid-cols-2  mx-6 italic">
            <label className="   expandedLabel fontExpand ">
              Install Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityDoorBuzzer.dbinstallVendorId,
                      officeSecurityData: securityDoorBuzzer,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...OfficeTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">
                  {securityDoorBuzzer.dbinstallVendorName}
                </span>
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-2  mx-6 italic">
            <label className="   expandedLabel fontExpand ">
              Warranty Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityDoorBuzzer.dbwarrantyVendorId,
                      officeSecurityData: securityDoorBuzzer,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...OfficeTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">
                  {securityDoorBuzzer.dbwarrantyVendorName}
                </span>
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-2  mx-6 italic">
            <label className="   expandedLabel fontExpand ">
              Servicing Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityDoorBuzzer.dbservicingVendorId,
                      officeSecurityData: securityDoorBuzzer,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...OfficeTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">
                  {securityDoorBuzzer.dbservicingVendorName}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // Office Key section
  const SecurityOfficeKeyAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                Office Keys
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs bg-white">
              {officeKeys?.map((officeKey, i) => {
                return (
                  <SecurityOfficeKeyCard
                    key={i}
                    securityOfficeKey={officeKey}
                  />
                );
              })}
              {officeKeys && officeKeys.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No Office Key Found
                </div>
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      {showDeactivateModalOfficeKey && (
        <ConfirmBoxDelete
          ModalTitle="Security Office Key"
          qConfirmation={deleteMessage}
          isOpen={showDeactivateModalOfficeKey}
          onClose={() => setShowDeactivateModalOfficeKey(false)}
          onClickFunction={() => handleDeactivateOfficeKey()}
          cancelButtonRef={undefined}
        />
      )}
    </div>
  );
  const SecurityOfficeKeyCard = ({ securityOfficeKey }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickOfficeKey(securityOfficeKey)}
              >
                {securityOfficeKey.lockSmithVendorId
                  ? "S-" +
                  String(securityOfficeKey.lockSmithVendorId).padStart(4, "0")
                  : ""}
              </div>
            </span>
            {userPermissions.includes(editSecurity) && (
              <Menu as="div" className="items-center flex">
                <div>
                  <Menu.Button className="">
                    <EllipsisHorizontalCircleIcon
                      className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            buttonText="Edit"
                            className={""}
                            onClick={() =>
                              onClickAdd(
                                "ForEdit",
                                securityOfficeKey,
                                "officeKeys"
                              )
                            }
                            disabled={false}
                          >
                            <label className="cursor-pointer fontLabel text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                              {" "}
                              <PencilSquareIcon className="h-4 w-4 " /> Edit
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                    {userPermissions.includes(deletePermission) ? (
                      <div className="px-1 py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              buttonText="Deactivate"
                              className={
                                !securityOfficeKey.isActive ||
                                  securityOfficeKey.isActive === 0
                                  ? "opacity-50"
                                  : "opacity-100"
                              }
                              onClick={() => {
                                setShowDeactivateModalOfficeKey(true);
                                setForDeleteDetails(securityOfficeKey);
                              }}
                              hasDeletePermission={hasDeletePermission}
                              disabled={
                                !securityOfficeKey.isActive ||
                                  securityOfficeKey.isActive == 0
                                  ? true
                                  : false
                              }
                            >
                              <label className="cursor-pointer fontLabel text-secondary flex items-center place-content-center hover:text-hsecondary underline relative  px-2 text-xs font-medium">
                                {" "}
                                <TrashIcon className="h-4 w-4 " /> Deactivate
                              </label>
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    ) : (
                      ""
                    )}
                  </Menu.Items>
                </Transition>
              </Menu>
            )}
          </div>

          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Locksmith Vendor:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              {/* <span className="text-tertiary  pr-2 underline ">
                          {sec.lockSmithVendor}
                        </span> */}
              <div
                className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer truncate ..."
                onClick={() => {
                  const url = "/officesettings/officesetting";
                  history.push({
                    pathname: "/vendortab/vendor",
                    state: {
                      vendorId: securityOfficeKey.lockSmithVendorId,
                      officeSecurityData: securityOfficeKey,
                      action: "OfficeSettingSecurity",
                    },
                  });
                  window.location.reload();
                  let userTabs = [
                    {
                      to: "",
                    },
                  ];
                  [...OfficeTabs].forEach((tabs) => {
                    let temp = [...userPermissions].filter(
                      (user) => user === tabs.permission
                    );
                    if (temp.length > 0)
                      userTabs.push({
                        to: tabs.to,
                      });
                  });
                  userTabs.shift();
                  const index = userTabs.findIndex((c) => c.to === url);
                  setSelectedIndex(index);
                }}
              >
                <span className="pr-2 ">
                  {securityOfficeKey.lockSmithVendor}
                </span>
              </div>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Vendor Address:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {securityOfficeKey.street +
                  " " +
                  securityOfficeKey.city +
                  " " +
                  ", " +
                  securityOfficeKey.state +
                  " " +
                  securityOfficeKey.zipCode}
              </span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Vendor phone:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityOfficeKey.okvendorPhone}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // HVAC section
  const SecuriyHVACAccordion = ({ security }) => (
    <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
      <Disclosure>
        {({ open }) => (
          <>
            <Disclosure.Button className="disclosureBtn ml-2">
              <ChevronRightIcon
                className={`${open ? "transform rotate-90" : ""
                  } text-gray-500 w-2 h-2 `}
              />
              <div className="disclosureLabel ml-2 text-gray-500 underline">
                HVAC
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-xs bg-white">
              {hvacs &&
                hvacs?.map((hvac, i) => {
                  return <SecurityHVACCard key={i} securityHVAC={hvac} />;
                })}
              {hvacs && hvacs.length < 1 && (
                <div className="flex justify-center text-xs italic col-span-3 p-2">
                  No HVAC Found
                </div>
              )}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      {showDeactivateModalHvac && (
        <ConfirmBoxDelete
          ModalTitle="Security HVAC"
          qConfirmation={deleteMessage}
          isOpen={showDeactivateModalHvac}
          onClose={() => setShowDeactivateModalHvac(false)}
          onClickFunction={() => handleDeactivateHvac()}
          cancelButtonRef={undefined}
        />
      )}
    </div>
  );
  const SecurityHVACCard = ({ securityHVAC }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className="px-4 py-2 border-b border-gray-200 ">
          <div className="flex justify-between m-1 gap-2">
            <span className="pr-2">
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                onClick={() => onClickHvac(securityHVAC)}
              >
                {securityHVAC.id
                  ? "S-" + String(securityHVAC.id).padStart(4, "0")
                  : ""}
              </div>
            </span>
            {userPermissions.includes(editSecurity) && (
              <Menu as="div" className="items-center flex">
                <div>
                  <Menu.Button className="">
                    <EllipsisHorizontalCircleIcon
                      className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                      aria-hidden="true"
                    />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            buttonText="Edit"
                            className={""}
                            onClick={() =>
                              onClickAdd("ForEdit", securityHVAC, "hvac")
                            }
                            disabled={false}
                          >
                            <label className="cursor-pointer fontLabel text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                              {" "}
                              <PencilSquareIcon className="h-4 w-4 " /> Edit
                            </label>
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                    {userPermissions.includes(deletePermission) ? (
                      <div className="px-1 py-1">
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              buttonText="Deactivate"
                              className={
                                !securityHVAC.isActive ||
                                  securityHVAC.isActive === 0
                                  ? "opacity-50"
                                  : "opacity-100"
                              }
                              onClick={() => {
                                setShowDeactivateModalHvac(true);
                                setForDeleteDetails(securityHVAC);
                              }}
                              hasDeletePermission={hasDeletePermission}
                              disabled={
                                !securityHVAC.isActive ||
                                  securityHVAC.isActive === 0
                                  ? true
                                  : false
                              }
                            >
                              <label className="cursor-pointer fontLabel text-secondary flex items-center place-content-center hover:text-hsecondary underline relative  px-2 text-xs font-medium">
                                {" "}
                                <TrashIcon className="h-4 w-4 " /> Deactivate
                              </label>
                            </button>
                          )}
                        </Menu.Item>
                      </div>
                    ) : (
                      ""
                    )}
                  </Menu.Items>
                </Transition>
              </Menu>
            )}
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Number of Units:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityHVAC.numberOfUnits}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Unit Type:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityHVAC.unitType}</span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Install Date:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">
                {securityHVAC.hvacinstallDate
                  ? new Date(securityHVAC.hvacinstallDate)?.toLocaleDateString()
                  : ""}
              </span>
            </div>
          </div>
          <div className="grid  grid-cols-2  ">
            <label className=" expandedLabel fontExpand text-left ml-2">
              Maintenance Company:
            </label>
            <div className="expandedLabel fontExpand text-left ml-2 truncate ...">
              <span className="pr-2">{securityHVAC.maintenanceCompany}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // File and Images section
  const SecuriyFilesAndImagesAccordion = ({ security }) => {
    let fileCatergory = security.fileCategoryList;

    return (
      <div className="my-2 mr-2 bg-white rounded-lg box-shadow p-1">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="disclosureBtn ml-2 block">
                <div className="flex justify-between">
                  <div className="flex gap-2 items-center disclosureLabel text-gray-500 underline ">
                    <ChevronRightIcon
                      className={`${open ? "transform rotate-90" : ""
                        } text-gray-500 w-2 h-2 `}
                    />
                    Files and Images
                  </div>
                  {userPermissions.includes(editSecurity) && (
                    <div>
                      {fileCatergory?.length > 0 ? (
                        <button
                          buttonText="Edit"
                          className={""}
                          onClick={() =>
                            onClickAdd("ForEdit", security, "FilesAndImages")
                          }
                          disabled={false}
                        >
                          <label className="cursor-pointer fontLabel mr-2 text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                            {" "}
                            <PencilSquareIcon className="h-4 w-4 " />
                            Edit
                          </label>
                        </button>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              </Disclosure.Button>
              <Disclosure.Panel className=" bg-white">
                <div className="">
                  {securityDetails?.fileCategoryList &&
                    securityDetails?.fileCategoryList?.map((x) => {
                      return (
                        <div className="px-5">
                          <Disclosure>
                            {({ open }) => (
                              <>
                                <Disclosure.Button className="w-full flex py-1 text-xs text-left focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                  <div className="bg-gray-100 items-center flex w-full justify-between py-2 shadow-md ">
                                    <div className="px-2">
                                      <div className="text-gray-500">
                                        <span className="">
                                          {x.securityFileCategory1}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="px-2 mt-1">
                                      <ChevronRightIcon
                                        className={`${open ? "transform rotate-90" : ""
                                          } text-gray-500 w-4 h-4 `}
                                      />
                                    </div>
                                  </div>
                                </Disclosure.Button>
                                <Disclosure.Panel>
                                  <div>
                                    <div className="flex flex-col shadow-md">
                                      {security.fileNames
                                        ?.filter(
                                          (y) => y.fileCategoryId === x.id
                                        )
                                        .map((file, i) => {
                                          return (
                                            <>
                                              <SecurityFilesAndImagesCard
                                                key={i}
                                                securityFile={file}
                                              />
                                            </>
                                          );
                                        })}
                                    </div>
                                  </div>
                                </Disclosure.Panel>
                              </>
                            )}
                          </Disclosure>
                        </div>
                      );
                    })}
                </div>
                <div>
                  <div className="grid grid-cols-1">
                    <div className="p-2 divide-y"></div>
                  </div>
                </div>
                {securityDetails.fileCategoryList === null && (
                  <div className="flex justify-center text-sm italic col-span-3 p-2">
                    No Files and Images Found
                  </div>
                )}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    );
  };
  const SecurityFilesAndImagesCard = ({ securityFile }) => (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-1">
        <div className=" flex items-center justify-between py-2 gap-x-2 border-b-2">
          <div className="expandedLabel fontExpand text-left ml-2  whitespace-normal">
            <span className="text-xs break-all">
              {securityFile.securityFileName}
            </span>
          </div>
          <div className="flex items-center flex-col">
            <SideNavDownloadBtn
              buttonValue="Download"
              className=""
              onClick={() => downloadFile(securityFile?.securityFileName)}
              disabled={undefined}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <>
        {securityDetails && securityDetails && (
          <div className="">
            <div className="grid grid-cols-1 sm:grid-cols-1">
              <div className="px-4 py-2">
                <div className="flex justify-between m-1 gap-2">
                  <span>
                    <div
                      className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer "
                      onClick={() => onClickSecurity(securityDetails)}
                    >
                      {securityDetails.recordNumber
                        ? "S-" +
                        String(securityDetails.recordNumber).padStart(4, "0")
                        : ""}
                    </div>
                  </span>
                  {userPermissions.includes(editDisabledSecurity) && (
                    <button
                      buttonText="Edit"
                      className={""}
                      onClick={() => {
                        onClickAdd("ForEdit", securityDetails, "security");
                        setSelectedRecordNumber(securityDetails.recordNumber);
                      }}
                      disabled={false}
                    >
                      <label className="cursor-pointer underline fontLabel text-quaternary flex items-center place-content-center hover:scale-90 relative  px-2 text-xs font-medium  hover:text-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                        {" "}
                        <PencilSquareIcon className="h-4 w-4 " /> Edit
                      </label>
                    </button>
                  )}
                </div>
                <SecurityAlarmAccordion />
                <SecurityCameraAccordion />
                <SecurityCardReaderAccordion />
                <SecurityFireAlarmSystemAccordion />
                <SecuritySafeDetailsAccordion />
                <SecurityDoorBuzzerAccordion />
                <SecurityOfficeKeyAccordion />
                <SecuriyHVACAccordion />
                <SecuriyFilesAndImagesAccordion security={securityDetails} />
              </div>
            </div>
          </div>
        )}
      </>
      <>
        {securityDetails === undefined && (
          <div className="flex justify-center text-xs italic col-span-3 p-2">
            No Security Found
          </div>
        )}
      </>
    </>
  );
};
export default OfficeSecurity;
